import React, {
    FormEvent, ReactNode, useEffect, useState,
} from "react";
import Styles from "./SavePrompt.module.scss";
import { useTheme } from "../../contexts/Theme";
import Button from "../theme/button/Button";

export interface SavePromptProps {
    shouldShow: boolean;
    text?: string;
    onReset?: () => void;
    onSave: (evt: FormEvent) => void;
    buttonText?: ReactNode;
    actions?: ReactNode;
}

export default function SavePrompt(props: SavePromptProps) {
    const [isResetClicked, setIsResetClicked] = useState<boolean>(false);

    const theme = useTheme();

    useEffect(() => {
        setIsResetClicked(false);
    }, [props.onReset]);

    if (!props.shouldShow) {
        return null;
    }

    const submit = (evt: FormEvent) => {
        const form = (evt.target as HTMLFormElement).closest("form");
        const isValid = !form || form?.reportValidity();
        if (isValid) {
            props.onSave?.(evt);
        }
    };

    if (theme.isV3) {
        return (
            <div className={Styles["save-container"]}>

                {isResetClicked && (
                    <div className={Styles["reset-container"]}>
                        Are you sure you want to reset back to the original?
                        <Button type="submit" variant="danger" size="medium" onClick={props.onReset}>
                            Confirm
                        </Button>
                    </div>
                )}
                {props.actions}
                {props.onReset && (
                    <Button
                        type="button"
                        variant="outline-gray"
                        size="medium"
                        onClick={() => setIsResetClicked(!isResetClicked)}
                    >
                        Reset
                    </Button>
                )}
                <Button type="submit" size="medium" variant="primary" onClick={submit}>
                    {props.buttonText ?? "Save"}
                </Button>

            </div>
        );
    }

    return (
        <div className="fixed-bottom">
            {isResetClicked && (
                <div className={`bg-default px-3 py-2 rounded mx-auto d-flex `
                + `justify-content-between align-items-center text-light ${Styles["save-container"]}`}
                >
                    Are you sure you want to reset back to the original?
                    <button type="submit" className="btn btn-danger text-gray-300" onClick={props.onReset}>
                        Confirm
                    </button>
                </div>
            )}

            <div className={`bg-default px-3 py-2 rounded mx-auto d-flex `
                + `justify-content-between align-items-center ${Styles["save-container"]}`}
            >
                <div className="text-gray-200 text-nowrap flex-grow-1">
                    {props.text}
                </div>
                {props.onReset && (
                    <button
                        type="button"
                        className="btn btn-none btn-small text-light "
                        onClick={() => setIsResetClicked(true)}
                    >
                        Reset
                    </button>
                )}
                <button type="submit" className="btn btn-secondary text-gray-300" onClick={submit}>
                    {props.buttonText ?? "Save"}
                </button>
            </div>
        </div>
    );
}

SavePrompt.defaultProps = {
    text: "Do you want to save changes?",
    onReset: undefined,
    buttonText: undefined,
    actions: undefined,
};
